import React from "react";
import { Styles } from "./styles";

const BigBlueButtonMeeting = (props) => {
  const { bigBlueButtonUrl } = props;

  return (
    <Styles>
      <div className="bbb-meeting">
        <iframe
          src={bigBlueButtonUrl}
          allow="camera *;microphone *;display-capture *;"
          allowfullscreen
        ></iframe>
      </div>
    </Styles>
  );
};

export default BigBlueButtonMeeting;
